import { GameItem } from 'dt-common/generated/prisma/client';
import { CavernsSubmodeKeyType } from 'dt-common/generated/types/enums';
import { ApiErrorMessage } from 'dt-common/types/ApiErrorMessages';
import Audio from '~/Audio';
import mutationDiscardCavernsLootItem from '~/graphql/caverns/mutationDiscardCavernsLootItem';
import { GraphQlRequestError } from '~/graphql/graphqlClient';
import { logError } from '~/logger';
import messages, { CavernsStoreMessage } from '../messages';

export default async function discardCavernsLootItem(
  {
    playerId,
    setLootPickedUp,
    getCurrentLoot,
    emit,
    onMissingCavernsRunData,
  }: {
    playerId: string | null;
    setLootPickedUp: (data: { gold: number; pd: number; items: GameItem[]; }) => void;
    getCurrentLoot: () => { gold: number; pd: number; items: GameItem[]; };
    emit: (message: CavernsStoreMessage, data?: any) => void;
    onMissingCavernsRunData: () => void;
  },
  { game_submode, item_id }: { game_submode: CavernsSubmodeKeyType; item_id: string; }
) {
  if (!playerId) {
    throw new Error('Player ID is required');
  }

  try {
    await mutationDiscardCavernsLootItem({
      playerId,
      game_submode,
      item_id,
    });

    // Update local state by filtering out the discarded item
    const currentLoot = getCurrentLoot();
    const filteredItems = currentLoot.items.filter(({ uid }) => uid !== item_id);
    setLootPickedUp({
      gold: currentLoot.gold,
      pd: currentLoot.pd,
      items: filteredItems,
    });

    emit(messages.TOTAL_LOOT_PICKED_UP, {
      gold: currentLoot.gold,
      pd: currentLoot.pd,
      items: filteredItems,
    });
    Audio.play('equipment_storage');
  } catch (err) {
    if (err instanceof GraphQlRequestError && err.errors.find((error) => error.message === ApiErrorMessage.NO_CURRENT_RUN_FOUND)) {
      onMissingCavernsRunData();
      return;
    }
    logError(err, {
      module: 'CavernsStore/handlers',
      func: 'discardCavernsLootItem',
      playerId,
      game_submode,
      item_id,
    });
  }
}

